import React from "react";
import { Layout } from "antd";
import styled from "styled-components";
import SidebarContent from "./sidebarContent";
import LogoLight from "../../images/admin-2.png";

const { Sider } = Layout;

const StyledSider = styled(Sider)`
  background: #1d194d !important;
  min-height: 100vh;
  position: sticky;
  top: 0;
  .ant-layout-sider-children ul {
    background-color: transparent !important;
  }
`;

const SidebarWrapper = (props) => {
  const { collapsed, toggleCollapsed } = props;
  let imageVisible;

  collapsed ? (imageVisible = "hidden") : (imageVisible = "visible");

  return (
    <StyledSider
      trigger={null}
      collapsible
      collapsed={collapsed}
      collapsedWidth={80}
      width="256px"
    >
      <div style={{ textAlign: "center" }}>
        <h3
          style={{
            width: "70%",
            padding: "20px 0",
            color:"white"
          }}
        >Admin Panel</h3>

      </div>

      <SidebarContent collapsed={collapsed} />
    </StyledSider>
  );
};

export default SidebarWrapper;
